import React, { FunctionComponent } from 'react';

import cn from 'classnames';

import ShareButton from './share-button';
import css from './styles.css';
import { ShareButtonProps, ShareButtonsBlockProps } from './types';

const ButtonsWrapper: FunctionComponent<ShareButtonsBlockProps & { buttonsSettings: ShareButtonProps[] }> = ({
    buttonsSettings,
    className,
    buttonClassName,
    iconClassName,
    hideButtons,
}) => {
    return (
        <div className={cn(css.ShareButtonsWrapper, className)}>
            {buttonsSettings.map((settings) => (
                <ShareButton
                    key={settings.href}
                    {...settings}
                    className={buttonClassName}
                    iconClassName={iconClassName}
                    hideButtons={hideButtons}
                />
            ))}
        </div>
    );
};

export default ButtonsWrapper;
